const topBarConstantsAR = {
  dashboard: 'القيادة',
  videos: 'فيديو',
  categories: 'فئات',
  resources: 'موارد',
};

export default topBarConstantsAR;
